import { render, staticRenderFns } from "./WorkExtraTypeModal.vue?vue&type=template&id=0b631ec1&"
import script from "./WorkExtraTypeModal.vue?vue&type=script&lang=js&"
export * from "./WorkExtraTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports